<div class="d-flex justify-content-between align-items-center bg-secondary mt-3 w-100 text-white px-4 py-2"
    *ngIf="students.length > 0">
    <label class="fs-5 m-0"><span class="vag-bold-font">RECIBOS</span>
        {{students[studentCurrent].fullname}}</label>
    <div>
        <button [disabled]="!students[studentCurrent + 1]" type="button" class="close mx-3" (click)="increaseIndex()">
            <fa-icon [icon]="chevronRight" class="text-white"></fa-icon>
        </button>
        <button [disabled]="!students[studentCurrent - 1]" type="button" class="close mx-3" (click)="decreaseIndex()">
            <fa-icon [icon]="chevronLeft" class="text-white"></fa-icon>
        </button>
    </div>
</div>
<div class="my-3" *ngIf="courseCurrent" >
    Curso: <select (change)="chooseCourseChild($event)">
        <option *ngFor="let course of students[studentCurrent]?.courseInfoArr" value="{{course.id}}">{{course.description}}</option>
    </select> {{courseCurrent.centerDescr}} {{showCourseDays(courseCurrent)}} {{showCourseShedule(courseCurrent)}}
</div>
<div class="container pt-3" *ngIf="students.length > 0">
    <div class="d-flex border-bottom pb-2 border-black">
        <div class="col vag-bold-font">
            Mes
        </div>
        <div class="col vag-bold-font">
            Año acádemico
        </div>
        <div class="col vag-bold-font">
            Estado
        </div>
        <div class="col vag-bold-font">
            Descarga
        </div>
    </div>
    <div class="d-flex border-bottom pb-2 border-black mt-2"
        *ngFor="let item of this.students[this.studentCurrent].receipts">
        <div class="col">
            {{this.months[item.month]}}
        </div>
        <div class="col">
            {{item.value.year}}
        </div>
        <div class="col" style="text-transform: capitalize;">
            {{item.value.state}}
        </div>
        <div class="col" *ngIf="!item?.estado">
            <a class="is_active" (click)="imprimirPdf(item)">Recibo</a>
        </div>
    </div>
</div>